export default __webpack_public_path__ + "static/media/26_bear.979391bb.JPG";